<template>
    <div class="custom-ag-dropdown">
        <form-group>
            <md-select v-model="currentValue">
                <md-option key="blank" :value="null">All</md-option>
                <md-option v-for="item in params.dropdownValues" :key="item.teamRegionId" :value="item">
                    {{ item.name }}
                </md-option>
            </md-select>
        </form-group>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentValue: null // Start with no selection
        };
    }
};
</script>
